import { actionTypes } from "../Actions/previewtext.action";

const INITIAL_STATE = {
  textData: [],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, { type, payLoad }) => {
  switch (type) {
    case actionTypes.CHAGE:
      return { ...state, ...payLoad };
    default:
      return state;
  }
};
